import { NavLink } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';
import { NavbarState } from 'stores/atoms/navbarState';

export default function CommonWsLayoutHeader(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [navbarState, setNavbarState] = useRecoilState(NavbarState);
  const [acctState] = useRecoilState(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * スマホ用メニューを開きます
   */
  const onOpenNavi = () => {
    setNavbarState({ open: !navbarState.open });
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <nav className={`navbar navbar-white ${navbarState.open ? 'hidden' : ''}`}>
      <div className="container">
        <NavLink to="/" className="navbar-brand">
          <img
            src={acctState.proxyLogin ? '/img/common/logo-proxy.svg' : '/img/common/logo.svg'}
            alt="BranQ ブランク"
          />
        </NavLink>
        <a
          onClick={onOpenNavi}
          className="navbar-toggler menu-trigger"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-white"
          aria-expanded={navbarState.open}
          aria-controls="navbar-white"
        >
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </a>
      </div>
    </nav>
  );
}
